import { toast } from "sonner";
import { errMsg, http } from "./api";

export const trashSong = async (s, reload) => {
  try {
    await http.delete(`/songs/${s.id}`);
  } catch (e) { return toast.error(errMsg(e)); }
  reload();
  toast.success(`„${s.title || "Daina"}“ perkelta į šiukšliadėžę`, {
    action: { label: "Atšaukti", onClick: () => http.post(`/songs/${s.id}/restore`).then(reload) },
  });
};
